import React from 'react';

function Solution() {
  return (
    <section className="section-padding bord-thin-top">
      <div className="container">
        <div className="row justify-content-end">
          <div className="col-lg-7">
            <div className="text">
              <h2 className="mb-50">The Solution</h2>
              <h5 className="mb-30 fw-400">
                Global concrete manufacturers engaging with us to develop
                specific testing programms.
              </h5>
              <p className="fz-18">
                Show your portfolio in a stylish and modern design. The template
                has a clean, professional code, the site is fully adaptive and
                unique. This is a template for those who appreciate minimalism
                and convenience. Embed videos, images, and a slider.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Solution;
